import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ImageThumbnail = ({ image, alt, ...otherProps }) => {
  if (image) {
    return <GatsbyImage image={getImage(image.childImageSharp)} alt={alt}  {...otherProps} />
  }
 
  return null;
}

ImageThumbnail.defaultProps = {
  alt: '',
};

export default ImageThumbnail;